import styled from "styled-components";
import { mobile } from "../../../../../../ui/_themes/constants";
import { Setting } from "../Setting";

export const ResetButton = styled(Setting)`
  margin-top: 1em;
  text-transform: uppercase;
  line-height: 3.9em;
  border-width: 0.2em;
  font-size: ${mobile.fontSize.xs};
`;
